<!-- 收银台 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div class="wechatPay-main">
      <div class="pay-message">
        <span>订单提交成功，请尽快付款！</span>
        <span>
          应付金额：
          <span style="color: red;font-weight: bold">{{orderInfo.surplusMoney}}</span>元
        </span>
      </div>
      <el-card class="box-card">
        <div class="wechatPay-title">
          <span>支付宝支付</span>
          <span>
            距离二维码过期还有
            <span class="color-red">{{countdown}}</span>
            秒,过期后请
            <span class="refresh" @click="refresh">刷新</span>
            页面重新获取二维码
          </span>
        </div>
        <div class="aliPay-main">
          <img src="../../../assets/images/ali-example.jpg" alt class="example" />
          <div class="qr-code-ctn">
            <p>扫一扫付款（元）</p>
            <p class="qrcode-header-money">{{orderInfo.surplusMoney}}</p>
            <div class="qrcode-img-wrapper">
              <div style="position: relative;height: 165px">
                <div class="invalid" v-show="isInvalid">
                  <div class="invalid-text">
                    <div>二维码已失效</div>
                    <br />
                    <el-button type="primary" @click="refresh">刷新</el-button>
                  </div>
                </div>
                <div class="invalid" v-show="isSuccess">支付成功</div>
                <img :src="QRImg" alt class="qr-code" />
              </div>
              <div class="qrcode-img-explain">
                <img src="../../../assets/images/aliPay-qr-icon.png" alt />
                <div>
                  <p>打开手机支付宝</p>
                  <p>扫一扫继续付款</p>
                </div>
              </div>
            </div>
            <a
              href="https://mobile.alipay.com/index.htm"
              target="_blank"
              class="download-alipay"
            >首次使用请下载手机支付宝</a>
          </div>
        </div>
        <div @click="back" class="back-pay">＜返回选择其他支付方式</div>
      </el-card>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    return {
      isSuccess: false, // 是否支付成功
      isInvalid: false, // 二维码是否失效
      countdown: 120,
      payWay: 0,
      showOrderMsg: false,
      vId: "",
      orderInfo: {},
      QRImg: ""
    };
  },
  mounted() {
    this.vId = this.$route.query.vId;
    this.getQRImg();
  },
  beforeDestroy() {
    this.$socketPay.closeSocket();
  },
  methods: {
    refresh() {
      window.location.reload();
    },
    timer() {
      let time = 120;
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer);
          this.isInvalid = true;
          return;
        }
        time = time - 1;
        this.countdown = time;
      }, 1000);
    },
    connectSoket(vId) {
      this.$socketPay.initWebSocket(vId).then(() => {
        this.$socketPay.receiveWebsocket(payRes => {
          if (payRes.paystate == 0) {
            this.isSuccess = true;
            this.$util.successMsg(payRes.msg);
            this.$router.push(`./paySuccess?vId=${this.vId}`);
          } else {
            this.$util.warningMsg(payRes.msg);
            this.$router.push(`./payFail?vId=${this.vId}`);
          }
        });
      });
    },
    getQRImg() {
      this.$util
        .axiosPost({
          url: `/api/SoftwareSets/AliPayRequest?vId=${this.vId}&uid=${
            this.$util.getLocalStorage("userMsg").EmployeeId
          }`,
          QRImg: true,
          exception: true,
          hideLoading: true
        })
        .then(response => {
          return (
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )
          );
        })
        .then(data => {
          this.QRImg = data;
          this.timer();
        });
    },
    back() {
      window.history.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.invalid-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.refresh {
  cursor: pointer;
  color: red;
  text-decoration: underline;
}
.example {
  position: absolute;
  right: 176px;
  top: 0px;
}
.download-alipay {
  margin-top: 20px;
  font-size: 12px;
  color: #a6a6a6;
  text-decoration: underline;
}
.qrcode-img-explain {
  padding: 10px 0 6px;
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }
  display: flex;
  justify-content: center;
}
.aliPay-main {
  margin-top: 30px;
  height: 400px;
  position: relative;
}
.qrcode-img-wrapper {
  width: 168px;
  height: auto;
  min-height: 168px;
  margin: 0 auto;
  padding: 6px;
  border: 1px solid #d3d3d3;
  -webkit-box-shadow: 1px 1px 1px #ccc;
  box-shadow: 1px 1px 1px #ccc;
  .qr-code {
    width: 156px;
    height: 156px;
  }
}
.qrcode-header-money {
  margin: 10px 0 20px 0;
  font-size: 26px;
  font-weight: 700;
  color: #f60;
}
.qr-code-ctn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 392px;
  text-align: center;
}
.back-pay {
  cursor: pointer;
  font-size: @font-sm;
  color: @theme;
}
.box-card {
  padding: 20px;
}
.wechatPay-title {
  > span:nth-child(1) {
    display: inline-block;
    width: 150px;
    font-size: @font-md;
  }
}
.wechatPay-main {
  width: 1000px;
  margin: 0 auto;
}
.pay-message {
  padding: 10px;
  font-size: @font-sm;
  line-height: 1.5em;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.invalid {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  width: 156px;
  height: 156px;
  z-index: 2;
  text-align: center;
  font-size: @font-lg;
  color: @font3Color;
}
</style>
